import { Inject } from '@odinjs/odin';

import { FetchAPI, FieldAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnMount, OnSelect } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, SelectEvent } from '@philips-emr/tws-core/lib/component/types';
import { MessageService } from '@philips-emr/tws-core/lib/services';

import { MensagemDetalhesAliases as Aliases, FragmentNames } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { DownloadService } from '../../services';
import BaseController from '../base/base-controller';

import './mensagem-detalhes.css';

import { Anexo } from './mensagens-controller';

@Controller({ fragment: FragmentNames.MENSAGEM_DETALHES })
class MensagemDetalhesController extends BaseController {
  @Inject(Aliases.FIELD_ANEXOS)
  private fieldAnexos: FieldAPI;

  @OnMount(Aliases.CONTEXTUAL_BAR_MENSAGEM)
  onMountContextualBarDetalhesMensagem(): void {
    const { nrSeqBeneficiario, nrSeqComunicado: nrSequencia } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqBeneficiario, nrSequencia });
  }

  @OnSelect(Aliases.HPMS_ATTACHMENTS_LIST)
  onSelectAnexo(event: SelectEvent<Anexo>): void {
    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    const { value } = event;
    const { nrSequencia: nrSeqAnexo, nmArquivo: filename } = value;
    DownloadService.of({
      endpoint: Endpoints.GET.DOWNLOAD_ANEXO_MENSAGEM,
      name: filename,
      parameters: { nrSeqBeneficiario, nrSeqAnexo },
    });
  }

  @OnAfterFetch(Aliases.FETCH_ANEXOS)
  onAfterFetchAttachments(event: FetchEvent): void {
    if (event.data) {
      const data = event.data as FetchAPI;
      if (data.length > 0) {
        this.fieldAnexos.setLabel(MessageService.translate('beneficiary.anexos'));
      }
    }
  }
}

export {
  MensagemDetalhesController,
};
